import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  bullets: string[];
  originalPrice: string;
  price: string;
  discountBadge: string;
  perUnitText: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK BABYFÚTBOL',
  description: '6 tomos + 6 bonos',
  bullets: ['✓ 480 sesiones listas', '✓ 40 semanas planificadas', '✓ 6 bonos incluidos'],
  originalPrice: '$51.000',
  price: '$19.990',
  discountBadge: '61% OFF',
  perUnitText: 'Menos de $42 por sesión',
  ctaText: 'SÍ, QUIERO MI MEGAPACK →',
  ctaHref: 'https://www.profepack.com/cart/48174772420864:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + MANUAL DEL DT GANADOR',
  description: '6 tomos + 6 bonos + El Manual del DT Ganador: Estrategia de Partido',
  bullets: ['✓ 480 sesiones listas', '✓ Estrategia de partido completa', '✓ Táctica para ganar desde el banco'],
  originalPrice: '$69.000',
  price: '$27.990',
  discountBadge: '59% OFF',
  perUnitText: 'Menos de $58 por sesión',
  ctaText: 'SÍ, QUIERO EL MEGAPACK + MANUAL DEL DT GANADOR →',
  ctaHref: 'https://www.profepack.com/cart/48174806237440:1',
  isFeatured: true,
  savings: 'AHORRÁS $41.010'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-8 sm:py-16 px-4" data-id="element-140">
      <div className="max-w-xl mx-auto" data-id="element-141">
        {/* Header */}
        <div className="text-center mb-2" data-id="element-142">
          <span className="inline-block bg-[#00C853]/10 text-[#00C853] font-bold text-xs sm:text-sm px-3 py-1 rounded-full border border-[#00C853]/20" data-id="element-143">
            ✅ +487 profes ya eligieron su MegaPack
          </span>
        </div>
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-144">
          Elegí tu{' '}
          <span className="text-[#00C853]" data-id="element-145">MegaPack BabyFútbol Listo:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-5 sm:mb-10" data-id="element-146">
          Las dos opciones incluyen los 6 bonos estratégicos
        </p>

        {/* Options */}
        <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-8" data-id="element-147">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-3 sm:p-6 transition-all ${isFeatured && isSelected ? 'border-2 border-[#00C853] bg-[#000d08] shadow-[0_0_30px_rgba(0,200,83,0.15)]' : isFeatured ? 'border-2 border-[#00C853]/50 bg-[#000d08]' : isSelected ? 'border-2 border-[#00C853] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-148">
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-149">
                  {/* Radio */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center mt-1 ${isSelected ? 'border-[#00C853]' : 'border-white/30'}`} data-id="element-150">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#00C853]" data-id="element-151" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-152">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-153">
                      <span className="text-lg" data-id="element-154">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-155">
                        {option.title}
                      </span>
                    </div>

                    {/* Badges */}
                    {isFeatured && <div className="flex items-center gap-2 mt-1.5 sm:mt-2 flex-wrap" data-id="element-156">
                        <span className="bg-[#00C853] text-black text-[11px] sm:text-xs font-black px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full" data-id="element-157">
                          ⭐ MÁS ELEGIDO
                        </span>
                        {option.savings && <span className="bg-[#00C853]/20 text-[#00C853] text-[11px] sm:text-xs font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full border border-[#00C853]/40" data-id="element-158">
                            {option.savings}
                          </span>}
                      </div>}

                    <p className="text-gray-400 text-sm mt-1 sm:mt-2 mb-0 sm:mb-2 hidden sm:block" data-id="element-159">
                      {option.description}
                    </p>

                    {/* Quick value summary bullets — hidden on mobile to keep CTA visible */}
                    <div className="hidden sm:flex flex-col gap-1 mt-2" data-id="element-160">
                      {option.bullets.map((bullet, idx) => <span key={idx} className="text-gray-300 text-xs sm:text-sm font-medium" data-id="element-161">
                          {bullet}
                        </span>)}
                    </div>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0 flex flex-col items-end" data-id="element-162">
                    <div className="flex items-center gap-2 mb-1" data-id="element-163">
                      <span className="bg-red-500/20 text-red-400 text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded border border-red-500/30" data-id="element-164">
                        {option.discountBadge}
                      </span>
                      <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-165">
                        {option.originalPrice}
                      </div>
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#00C853]' : 'text-white'}`} data-id="element-166">
                      {option.price}
                    </div>
                    <div className="text-[#00C853] text-[10px] sm:text-xs font-semibold mt-1" data-id="element-167">
                      {option.perUnitText}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Urgency near CTA */}
        <div className="text-center mb-3" data-id="element-168">
          <span className="text-[#FF8A80] text-sm font-bold animate-pulse" data-id="element-169">
            ⏰ Precio de lanzamiento — quedan pocos cupos
          </span>
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full text-center bg-[#00C853] text-black font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#00E676] transition-colors" data-id="element-170">
          {selectedOption.ctaText}
        </a>

        {/* Subtitle under CTA - Stronger risk reversal */}
        <p className="text-white text-sm sm:text-base font-medium text-center mt-4" data-id="element-171">
          🛡️ Si no te sirve, te devolvemos todo. Sin preguntas. 7 días.
        </p>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 mt-6 sm:mt-8 bg-[#0a0a0a] border border-[#00C853]/20 rounded-xl py-3 sm:py-4 px-4 sm:px-6" data-id="element-172">
          <span data-id="element-173">🔒 Pago seguro</span>
          <span data-id="element-174">⚡ Acceso en 5 min</span>
          <span data-id="element-175">🛡️ Garantía 7 días</span>
          <span data-id="element-176">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}